import { LogManager } from 'core/logging/LogManager';

const logger = LogManager.getLogger('registerServiceWorker');

const SERVICE_WORKER_URL = import.meta.env.DEV
  ? '/src/core/azure-map-tiles-cache/azureMapTilesCache.ts' // Development service worker
  : '/azureMapTilesCache.js'; // Production service worker

export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register(SERVICE_WORKER_URL, {
        type: 'module',
        scope: '/',
      })
      .then(registration => {
        logger.debug('[Service Worker] Registered successfully', registration);
      })
      .catch(error => {
        logger.error('[Service Worker] Registration failed', error);
      });
  }
};
